
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/me/[handle]/[[...context]]",
      function () {
        return require("private-next-pages/me/[handle]/[[...context]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/me/[handle]/[[...context]]"])
      });
    }
  